import { CommunityBannerType } from '@uniquegood/realworld-admin-interface';

export const communityBannerTypeToLabel: Record<CommunityBannerType, string> = {
  [CommunityBannerType.Image]: '이미지 배너',
  [CommunityBannerType.Notice]: '공지 배너'
};
